import { ConsentCookieBanner } from './app'

ConsentCookieBanner({ showClose: true })
ConsentCookieBanner.onFontsLoaded()
